<template>
  <div class="flight-row">
    <v-row class="flight-divider">
      <v-col cols="8">
        <span class="white px-2 ml-12 primary--text flight-divider-text">
          {{ contextLabel }}
        </span>
      </v-col>
      <v-col cols="2">
        <span class="white px-2 grey--text" v-if="transfers > 0">
          {{ transfersText }}
        </span>
      </v-col>
      <v-spacer />
      <v-col cols="2" class="text-right primary--text"
        ><span class="white px-4 mr-10"> {{ travelTime }} </span></v-col
      >
    </v-row>
    <v-row>
      <v-col cols="12" md="4" class="text-md-right">
        <div class="flight-content">
          <span class="flight-content-airport-code accent--text">{{ start_airport_code }}</span>
          <v-tooltip color="white" bottom>
            <template #activator="{on}">
              <span v-on="on" class="flight-content-time">{{ start_time != null ? start_time.substr(0, 5) : $t("global.noData") }}</span>
            </template>
            <span style="color: #0f0f0f"
              >{{ start_time != null ? start_time.substr(0, 5) : $t("global.noData") }}
              {{ start_date != null ? dayOfWeek(start_date) + " " + formatDateView(start_date) : $t("global.noData") }}</span
            >
          </v-tooltip>
        </div>
        <div class="flight-content-airport-name">{{ start_airport_name }}</div>
      </v-col>
      <v-col cols="12" md="4" class="text-center px-4">
        <v-icon x-large>flight_takeoff</v-icon>
        <div style="display: inline-block; width: 400px; max-width: calc(100% - 90px); padding: 0 10px;">
          <div></div>
          <v-divider class="route-line" />
          <div class="dot-container">
            <div v-if="transfers > 0">
              <div class="dot" v-for="i in parseInt(transfers)" :key="i" />
            </div>
          </div>
          <div class="grey--text">
            <span v-if="transfers > 0">
              {{ transfersText }}
            </span>
            <span v-else>
              {{ $t("booking.direct") }}
            </span>
          </div>
        </div>
        <v-icon x-large>flight_land</v-icon>
      </v-col>
      <v-col cols="12" md="4" class="text-md-left">
        <div class="flight-content">
          <span class="flight-content-airport-code accent--text">{{ end_airport_code }}</span>
          <v-tooltip color="white" bottom>
            <template #activator="{on}">
              <span v-on="on" class="flight-content-time">{{ end_time != null ? end_time.substr(0, 5) : $t("global.noData") }}</span>
            </template>
            <span style="color: #0f0f0f"
              >{{ end_time != null ? end_time.substr(0, 5) : $t("global.noData") }}
              {{ end_date != null ? dayOfWeek(end_date) + " " + formatDateView(end_date) : $t("global.noData") }}</span
            >
          </v-tooltip>
        </div>
        <div class="flight-content-airport-name">{{ end_airport_name }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dayOfWeek from "../../../repository/shortDayOfWeekFromDate";
import filterOverAllProperty from "../../../repository/filterOverAllProperty";
import getTextDateDiff from "../../../repository/getTextDateDiff";
import formatDateView from "../../../repository/fotmatDateView";

export default {
  name: "BookingFlightPartDetail",
  props: {
    transfers: {
      required: false,
      default: 0
    },
    start_date: {
      required: true
    },
    end_date: {
      required: true
    },
    start_time: {
      required: true
    },
    end_time: {
      required: true
    },
    start_airport_code: {
      required: true
    },
    end_airport_code: {
      required: true
    },
    start_airport_name: {
      required: true
    },
    end_airport_name: {
      required: true
    },
    label: {
      required: false,
      default: null
    }
  },
  data: () => ({}),
  computed: {
    contextLabel() {
      if (this.label == null) {
        return this.$t("booking.part");
      }
      return this.label;
    },
    travelTime() {
      let startDateTime = this.start_date + " " + this.start_time;
      let endDateTime = this.end_date + " " + this.end_time;
      return getTextDateDiff(startDateTime, endDateTime);
    },
    transfersText() {
      return this.transfers + " " + (this.transfers > 1 ? this.$t("booking.transfer") : this.$t("booking.transfers"));
    }
  },
  methods: {
    dayOfWeek: dayOfWeek,
    filterOverAllProperty: filterOverAllProperty,
    formatDateView: formatDateView
  }
};
</script>

<style scoped>
.flight-divider {
  font-weight: 700;
  position: relative;
  top: -20px;
}

.flight-divider-text {
  text-transform: uppercase;
}

.flight-content {
  font-size: 24px;
  font-weight: 700;
}

.flight-content-airport-code {
  font-size: 18px;
}

.flight-content-airport-name {
  color: #909194;
}

.flight-content-time {
}

.dot {
  position: relative;
  width: 6px;
  height: 6px;
  background-color: #44d3af;
  border-radius: 50%;
  display: inline-block;
  margin: 0 20px;
}

.dot-container {
  height: 6px;
  margin-bottom: 10px;
}

.route-line {
  top: 12px;
  position: relative;
}

.flight-row {
  margin-bottom: 15px;
}
</style>
